// extracted by mini-css-extract-plugin
export default {"RecipientEmail":"referrals-form_RecipientEmail__xlPqa","Recaptcha":"referrals-form_Recaptcha__IKIS3"};